export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_TOKEN (state, token) {
    state.token = token
  },
  FETCH_PACKINSTALLEDSAUVEGARDE (state, packinstalled) {
    state.packinstalled = packinstalled
  },
  FETCH_SERVICEMONITORING (state, servicemonitoring) {
    state.servicemonitoring = servicemonitoring
  },
  SET_ADMINSTATUS (state, status) {
    state.adminStatus = status
  },
  SET_USERID (state, userId) {
    state.userId = userId
  },
  SET_USERNAME (state, userName) {
    state.userName = userName
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js